module.exports = __webpack_public_path__ + "static/media/35.4e33476a.jpg";